import { useEffect } from 'react';

import { SigningInSpinner } from '~src/authentication/components/loginSpace/SigningInSpinner';
import { AuthenticationService } from '~src/authentication/services/AuthenticationService';
import { AuthenticationType } from '~src/settings/types/IServerSettingsUnauthenticated';

import { RootLoginUiProps } from './RootLoginUi';
import React = require('react');

export interface AutoLoginProps extends RootLoginUiProps {
    serverAuthType: AuthenticationType;
    onFailedAutoLogin: (errorCode: number) => void;
}

export function AutoLogin(props: AutoLoginProps) {
    useEffect(
      () => {
        AuthenticationService.autoLogin(props.signinQueryParams).then(
          () =>
            AuthenticationService.redirectAfterSuccessfulLogin(
              props.signinQueryParams
            ),
          props.onFailedAutoLogin
        );
      },
      // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    return <SigningInSpinner />;
}
